import axios from "../axios";

/**
 * 培训申报列表
 */
export const getPxsbList = (data) => {
  return axios({
    url: '/pxgl/list',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}
/**
 *  保存
 */
export const savePxsb = (data) => {
  return axios({
    url: '/pxgl/save',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}
/**
 *  删除
 */
export const removePxsb = (data) => {
  return axios({
    url: '/pxgl/delete',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}
/**
 * 提交
 */
export const submitPxsb = (data) => {
  return axios({
    url: '/pxgl/submit',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}
// 审核
export const toExaminePxsb = (data) => {
  return axios({
    url: '/pxgl/toExamine',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}

/**
 *  根据id查询
 */
export const selectByPxsbId =(id)=>{
  return axios({
    url: `/pxgl/view?id=${id}`,
    method: 'post'
  })
}
// 判断是否能申报
export const isReport =(deptId)=>{
  return axios({
    url: `/pxgl/isReport?deptId=${deptId}`,
    method: 'post'
  })
}

export const downloadApplication = (data) => {
  return axios({
    url: '/pxgl/downloadApplication',
    method: 'post',
    data,
    responseType: 'blob'
  }).then(res => {
    console.log(res)
    if (res) {
      openDownloadDialog(res, data.name)
    }
  })
}
// 导出
export const exportSbtjb = (name, data) => {
  return axios({
    url: "/pxgl/exportSbtjb",
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    responseType: 'blob',
    noSerializeData: true,//不序列化参数
    data: data
  }).then(res => {
    console.log(res)
    if (res) {
      openDownloadDialog(res, name)
    }
  })
}
let openDownloadDialog = function (blob, fileName) {
  if (window.navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(blob, fileName);
  } else {
    const elink = document.createElement('a')
    elink.download = fileName
    elink.style.display = 'none'
    elink.href = URL.createObjectURL(blob)
    document.body.appendChild(elink)
    elink.click()
    URL.revokeObjectURL(elink.href) // 释放URL 对象
    document.body.removeChild(elink)
  }
}
/**
 *  培训申报人员信息
 */

// 单位人员登记列表
export const getResidencePersonnelList = (data) => {
  return axios({
    url: '/pxgl/getResidencePersonnelByTrainIdList',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}
// 根据id查询 getPersonnelById
export const getPersonnelById =(id)=>{
  return axios({
    url: `/pxgl/getPersonnelById?id=${id}`,
    method: 'post'
  })
}

// 保存 or 提交 人员登记信息

export const savePersonnel = (data) => {
  return axios({
    url: '/pxgl/savePersonnel',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}
/**
 *  删除
 */
export const deletePersonnel = (data) => {
  return axios({
    url: '/pxgl/deletePersonnel',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}
// 审核
export const toPersonnelExamine = (data) => {
  return axios({
    url: '/pxgl/toPersonnelExamine',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}
export const downloadRyApplication = (data) => {
  return axios({
    url: '/pxgl/downloadRyApplication',
    method: 'post',
    data,
    responseType: 'blob'
  }).then(res => {
    console.log(res)
    if (res) {
      openDownloadDialog(res, data.name)
    }
  })
}

// 删除工作经历信息
export function removeWorkInfo(id){
  return axios({
    url: `/pxry/work/deleteWorkInfo?id=${id}`,
    method: 'post'
  })
}
// 导出汇总表
export const exportRySummary = (data) => {
  return axios({
    url: '/pxgl/exportRySummary',
    method: 'post',
    data,
    responseType: 'blob'
  }).then(res => {
    if (res) {
      openDownloadDialog(res, data.name)
    }
  })
}

// 判断导出条件
export function getRylxSummary(rylx,trainId,deptId){
  return axios({
    url: `/pxgl/getRylxSummary?rylx=${rylx}&trainId=${trainId}&deptId=${deptId}`,
    method: 'post'
  })
}

// 获取当前单位最新培训登记数据
export function  getPxdwByDeptIdOfNewInfo(deptId){
  return axios({
    url: `/pxgl/getPxdwByDeptIdOfNewInfo?deptId=${deptId}`,
    method: 'post'
  })
}

// 导出人员照片 exportRyImage

export const exportRyImage = (data) => {
  return axios({
    url: '/pxgl/exportRyImage',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data,
    responseType: 'blob'
  }).then(res => {
    if (res) {
      openDownloadDialog(res, data.name)
    }
  })
}

// 删除项目信息
export const  removeProjectInfo = (id) => {
  return axios({
    url: `/pxgl/project/delete?id=${id}`,
    method: 'post'
  })
}

// 删除评估员列表信息
export const  removePgyInfo = (id) => {
  return axios({
    url: `/pxgl/techie/delete?id=${id}`,
    method: 'post'
  })
}

// 删除设备列表信息
export const  removeDeviceInfo = (id) => {
  return axios({
    url: `/pxgl/device/delete?id=${id}`,
    method: 'post'
  })
}

export const  getDwmcByShtg = () => {
  return axios({
    url: `/pxgl/getDwmcByShtg/`,
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/pgdj.js